/**
 * streamlines add a dynamic value to marginBottom.
 * @param {object} param0
 * @param {number|string} param0.$marginBottom
 * @returns {string}
 */
const dynMarginBottom = ({ $marginBottom }) => {
  if ($marginBottom === undefined) return "";
  if (typeof $marginBottom === "number")
    return `margin-bottom: ${$marginBottom}px;`;
  return `margin-bottom: ${$marginBottom};`;
};

export default dynMarginBottom;
